import { AlertCircleIcon } from "@hugeicons-pro/core-stroke-rounded";
import { FC } from "react";
import { ConfirmDialog } from "shared/components/modals/ConfirmDialog";

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending?: boolean;
}

export const CancelNewIncomeRequestModal: FC<Props> = ({
  open,
  onClose,
  onConfirm,
  isPending = false
}) => (
  <ConfirmDialog
    opened={open}
    onClose={onClose}
    onConfirm={onConfirm}
    variant="danger"
    icon={{ icon: AlertCircleIcon }}
    title="Cancel verification"
    description="You're about to cancel the income verification. Boom will notify the applicant, and you won't be charged for the incomplete report."
    hideCancelButton
    confirmButton={{
      label: "Cancel request",
      loading: isPending,
      disabled: isPending
    }}
  />
);
